/* eslint-disable react/prop-types */
import React from 'react';
import PropTypes from 'prop-types';

import classNames from 'classnames/bind';

import styles from './section-with-container.module.scss';

const cx = classNames.bind(styles);

const SectionWithContainer = ({ content }) => (
  <section className={cx('wrapper')}>
    <div className="container">
      <div className={cx('inner')} dangerouslySetInnerHTML={{ __html: content }} />
    </div>
  </section>
);

SectionWithContainer.propTypes = {
  content: PropTypes.node.isRequired,
};

export default SectionWithContainer;
